import { Cell } from '../grid/Cell'
import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const InfoModal = ({ isOpen, handleClose }: Props) => {
  return (
    <BaseModal title="How to play" isOpen={isOpen} handleClose={handleClose}>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        Guess the word in 6 tries. After each guess, the colour of the tiles will change to show how close your guess was to the word. Correct answers could include Australian place names, animals, slang, etc.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell
          isRevealing={true}
          isCompleted={true}
          value="K"
          status="correct"
        />
        <Cell value="O" />
        <Cell value="A" />
        <Cell value="L" />
        <Cell value="A" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        The letter K is in the word and in the correct spot.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell value="B" />
        <Cell value="O" />
        <Cell
          isRevealing={true}
          isCompleted={true}
          value="G"
          status="present"
        />
        <Cell value="A" />
        <Cell value="N" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        The letter G is in the word but in the wrong spot.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell value="C" />
        <Cell value="O" />
        <Cell value="A" />
        <Cell isRevealing={true} isCompleted={true} value="S" status="absent" />
        <Cell value="T" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        The letter S is not in the word in any spot.
      </p>

      <p className="mt-6 italic text-sm text-gray-500 dark:text-gray-300">
        OzWord by <a href="https://www.yourlifechoices.com.au/" className='underline outline-none' target="_blank" rel="noreferrer">YourLifeChoices</a>.<br />
        The code is based on <a
          href="https://github.com/cwackerfuss/react-wordle"
          className="underline outline-none"
          target="_blank" rel="noreferrer"
        >
          React Wordle by cwackerfuss
        </a>
      </p>
    </BaseModal>
  )
}
